import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from './../redux/hooks';
import { useTheme } from '../themeContext';

// -- Redux 

// -- Components 

import Notification from '../components/general/notification/Notification';
import NavBar from '../components/general/navBar/NavBar';
import DoctorSettings from '../components/doctor/navigation/navBar/Settings'; 
import Container from '../components/consultationNote/Container';
import LockScreenWarning from '../components/lockScreen/warning/LockScreenWarning';
import Page from '../components/general/containers/Page';

const ConsultationNote: React.FC = () => {

  const dispatch = useAppDispatch(); 

  const colors = useAppSelector(state => state.theme.colors);

  const { isLightMode, toggleTheme } = useTheme();

  const navigate = useNavigate();
  const { t } = useTranslation();

  // -- 

  return (

    <Page>

        <Container />

        <NavBar disableShadow >
            <DoctorSettings /> 
        </NavBar>

        <LockScreenWarning />

    </Page>
  );
};

export default ConsultationNote;